import { triggerWalletConnect } from '@/features/analytics'
import { Button } from '@/ui/atoms/button/Button'
import { cn } from '@/ui/utils/style'

export interface ConnectCTAButtonGroupProps {
  header?: string
  buttonText: string
  action: () => Promise<void> | void
  source?: string
  className?: string
}

export function ConnectCTAButtonGroup({
  header,
  action,
  buttonText,
  source = 'unknown',
  className,
}: ConnectCTAButtonGroupProps) {
  return (
    <div className={cn('flex w-full flex-col gap-6', className)}>
      <div className="flex flex-col gap-3">
        <h4 className="text-center font-semibold text-base sm:text-xl">{header}</h4>
        <Button onClick={() => void triggerWalletConnect(action, source)} rounded="full">
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
